<template>
  <div v-if="isLoading" class="comment-list__container">
    <p class="comment-list__text-info">Loading reports...</p>
  </div>
  <div v-else class="comment-list__container">
    <div v-if="comments && comments.length > 0">
      <h3>Reports:</h3>
      <ul class="comment-list__list">
        <CommentItem
          v-for="comment in comments"
          :key="comment['_.id']"
          :comment="comment"/>
      </ul>
    </div>
    <div v-else>
      <p className="comment-list__text-info">There are no reports to be shown.</p>
    </div>
  </div>
</template>

<script>
import CommentItem from '@/components/CommentItem'

export default {
  name: 'CommentList',
  components: {
    CommentItem
  },
  props: {
    isLoading: Boolean,
    comments: Array
  }
}
</script>

<style scoped>
  .comment-list__container {
    text-align: left;
  }
  .comment-list__text-info {
    text-align: center;
    margin: 20px auto 0px auto;
  }
  .comment-list__list {
    list-style: none;
    margin: 0px;
    padding: 0px;
  }
</style>
